import { Dialog, DialogTitle, DialogContent, DialogActions, Button, IconButton } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import CustomTobPlanForm from './CustomTobPlanForm';

export default function CustomTobPlanFormDialog({ open, onClose, ...formProps }) {
    return (
        <CustomTobPlanForm
            {...formProps}
            active={open}
            renderLayout={({ header, content }) => (
                <Dialog
                    sx={{
                        '& .MuiDialog-paper': {
                            borderRadius: 7,
                            py: 1.5,
                            px: 1.5,
                            backgroundColor: '#f1f4fa',
                        },
                    }}
                    open={open}
                    onClose={onClose}
                    // Esc cancels the cell edit in progress -- it must not take the whole form with it.
                    disableEscapeKeyDown
                    fullWidth
                    maxWidth="xl">
                    {/* The chips and the toolbar act on the table, so they stay pinned in the
                        title while only the table scrolls underneath them. */}
                    <DialogTitle component="div" sx={{ pb: 1, position: 'relative' }}>
                        <IconButton
                            onClick={onClose}
                            sx={{ position: 'absolute', right: 12, top: 12, color: (theme) => theme.palette.grey[500] }}
                        >
                            <CloseIcon />
                        </IconButton>
                        {header}
                    </DialogTitle>
                    <DialogContent>
                        {content}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={onClose} color="primary">Close</Button>
                    </DialogActions>
                </Dialog>
            )}
        />
    );
}
